var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loader'),_vm._v(" "),(!_vm.isNormalPage)?_c('div',{staticClass:"main"},[_c('router-view')],1):_vm._e(),_vm._v(" "),(_vm.isNormalPage)?_c('div',{staticClass:"main"},[_c('section',{staticClass:"sidebar hidden-sm-down"},[_c('Sidebar')],1),_vm._v(" "),_c('section',{staticClass:"main-content withsidebar"},[_c('div',{staticClass:"f-wrap"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ea80aec","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = DcXO
// module chunks = 1